import styled from 'styled-components';
import { useState } from 'react';

interface RelatedItemProps {
  unitno: string;
  bid: string;
  iidx: number;
}

interface RelatedItemTabProps {
  relatedItem: RelatedItemProps[];
  number: string | undefined;
}

const RelatedItemTab = ({ relatedItem, number }: RelatedItemTabProps) => {
  const baseURL = new URL(window.location.href).origin;
  const [isRelatedItemOpen, setIsRelatedItemOpen] = useState(false);

  return (
    <div style={{ position: 'relative' }}>
      <Container>
        관련 물건번호
        <RelatedItemDiv
          onClick={() => {
            if (relatedItem.length <= 1) return;
            setIsRelatedItemOpen(!isRelatedItemOpen);
          }}
          isOpen={isRelatedItemOpen}
        >
          <span
            style={{
              color: relatedItem.length <= 1 ? 'rgba(55, 56, 60, 0.16)' : '',
            }}
          >
            목록
          </span>
          <img
            src={
              relatedItem.length <= 1
                ? '/assets/images/arrow/gray_arrrow_down_20.svg'
                : isRelatedItemOpen
                  ? '/assets/images/arrow/black_arrow_up_20.svg'
                  : '/assets/images/arrow/black_arrow_down_20.svg'
            }
            alt=""
            style={{ width: '20px', height: '20px' }}
          />
        </RelatedItemDiv>
      </Container>
      <RelatedItemList>
        {isRelatedItemOpen &&
          relatedItem.map((item, index) => (
            <RelatedItem
              key={index}
              onClick={() => {
                window.open(`${baseURL}/auction/detail/${item.iidx}`, '_blank');
              }}
              style={{
                backgroundColor:
                  item.iidx === Number(number) ? '#E6F3FF' : 'transparent',
                color: item.iidx === Number(number) ? '#008aff' : '',
              }}
            >
              <span style={{ color: item.bid === '매각' ? '#FA4032' : '' }}>
                {index + 1} {item.bid}
              </span>
            </RelatedItem>
          ))}
      </RelatedItemList>
    </div>
  );
};

export default RelatedItemTab;

const Container = styled.div`
  width: 100%;
  padding: 12px 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
  flex-wrap: wrap;
  background-color: rgba(112, 115, 124, 0.05);
`;

const TitleTabBox = styled.div`
  display: flex;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  font-size: 14px;
  font-weight: 500;
  color: #616161;
`;
const RelatedItem = styled.div`
  width: 100%;
  padding: 8px 0px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  //color: #008aff;
  cursor: pointer;
  white-space: nowrap;
  font-size: 14px;
`;

const RelatedItemList = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 101;
  position: absolute;
  background-color: #fff;
  border-radius: 16px;
  right: 10px;
  top: 50px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const RelatedItemDiv = styled.div<{ isOpen: boolean }>`
  backgound-color: #fafafb;
  padding: 4px 4px 4px 10px;
  border: 1px solid #e5e8ea;
  border-radius: 9999px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color: #222222;
`;
